"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkOrButton = void 0;
var _button = _interopRequireDefault(require("@clayui/button"));
var _link = _interopRequireDefault(require("@clayui/link"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["buttonDisplayType", "buttonType", "href", "linkDisplayType", "onClick"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var LinkOrButton = exports.LinkOrButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var buttonDisplayType = _ref.buttonDisplayType,
    buttonType = _ref.buttonType,
    href = _ref.href,
    linkDisplayType = _ref.linkDisplayType,
    onClick = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (href) {
    return /*#__PURE__*/_react.default.createElement(_link.default, _extends({}, otherProps, {
      displayType: linkDisplayType,
      href: href,
      onClick: onClick,
      ref: ref
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, otherProps, {
    displayType: buttonDisplayType,
    onClick: onClick,
    ref: ref,
    type: buttonType
  }));
});
LinkOrButton.displayName = 'ClayLinkOrButton';